import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { EmailIntegrationService } from 'src/app/_services/email-integration.service';
import { environment } from 'src/environments/environment';
const frontendurl = environment.frontendurl

@Component({
  selector: 'app-email-campaign-outlook-button',
  templateUrl: './email-campaign-outlook-button.component.html',
  styleUrls: ['./email-campaign-outlook-button.component.scss']
})
export class EmailCampaignOutlookButtonComponent implements OnInit {
  authurl: string
  @Output() outlookConnect: EventEmitter<any> = new EventEmitter();
  constructor(private emailintegrationservice: EmailIntegrationService) { }

  ngOnInit() {
  }
  connectoOutlook(){
    let data ={
      "redirectionurl": `${frontendurl}/email_redirection`
    }
    this.emailintegrationservice.outlookintegrationurl(data).subscribe((res:any)=>{
      if(res.status == 'success'){
        this.authurl = res.url
        var winObj = window.open(this.authurl, '_blank', 'location=yes,height=570,width=520,scrollbars=yes,status=yes');
        const loop = setInterval(() => {
          if (winObj.closed) {
            clearInterval(loop);
            this.outlookConnect.emit({ success: true, message: 'connected' });
          }
        }, 1000);
      }else{
        this.outlookConnect.emit({ success: false, error: res.message });
      }
    })
  }
}
